<template>
  <div>
    <b-row class="border_right_info border-bottom">
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_term_state}: `"
            :rules="$v.term_state_selected.$params"
            :showRequired="mode === 'add'"
          />
          <selectFind
            :options="term_state_options"
            v-model="$v.term_state_selected.$model"
            label="state_caption"
            id="state_name"
            :disabled="mode === 'edit'"
            :loading="term_state_loading"
            :isValid="
              $v.term_state_selected.$dirty
                ? !$v.term_state_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.term_state_selected.$dirty
                ? !$v.term_state_selected.$error
                : null
            "
          >
            <div v-if="!$v.term_state_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.select_term_state)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.state_prerequisite_name}: `"
            :rules="$v.state_prerequisite_name_selected.$params"
          />
          <selectFind
            :options="term_state_options"
            v-model="$v.state_prerequisite_name_selected.$model"
            label="state_caption"
            id="state_name"
            :disabled="state_prerequisite_name_disabled"
            :loading="term_state_loading"
            :isValid="
              $v.state_prerequisite_name_selected.$dirty
                ? !$v.state_prerequisite_name_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.state_prerequisite_name_selected.$dirty
                ? !$v.state_prerequisite_name_selected.$error
                : null
            "
          >
            <div v-if="!$v.state_prerequisite_name_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.state_prerequisite_name)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.max_day_status_completed} (روز): `"
            :rules="$v.max_day_status_completed.$params"
            :showInfo="true"
            :titleText="$lang.profileLang.select_term_state_tooltip"
          />
          <b-form-input
            v-model="$v.max_day_status_completed.$model"
            type="number"
            autocomplete="off"
            :state="
              $v.max_day_status_completed.$dirty
                ? !$v.max_day_status_completed.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.max_day_status_completed.$dirty
                ? !$v.max_day_status_completed.$error
                : null
            "
          >
            <div v-if="!$v.max_day_status_completed.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.max_day_status_completed)
              }}
            </div>
            <div v-if="!$v.max_day_status_completed.numeric">
              {{
                $lang.error_numeric | replace($lang.max_day_status_completed)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-if="hasPayment">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.cost} (ریال): `"
            :rules="$v.cost.$params"
          />
          <b-form-input
            v-model="$v.cost.$model"
            type="number"
            autocomplete="off"
            :state="$v.cost.$dirty ? !$v.cost.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.cost.$dirty ? !$v.cost.$error : null"
          >
            <div v-if="!$v.cost.required">
              {{ $lang.error_required | replace($lang.profileLang.cost) }}
            </div>
            <div v-if="!$v.cost.numeric">
              {{ $lang.error_numeric | replace($lang.profileLang.cost) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-if="hasPayment">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.gate_number}: `"
            :rules="$v.gate_selected.$params"
          />
          <selectFind
            :options="gate_options"
            v-model="$v.gate_selected.$model"
            label="caption"
            id="code"
            :loading="gate_loading"
            :isValid="$v.gate_selected.$dirty ? !$v.gate_selected.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.gate_selected.$dirty ? !$v.gate_selected.$error : null"
          >
            <div v-if="!$v.gate_selected.required">
              {{
                $lang.error_required | replace($lang.profileLang.gate_number)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_warning border-bottom pt-3">
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_role}: `"
            :rules="$v.role_selected.$params"
            :showInfo="true"
            :titleText="$lang.profileLang.select_role_term_state_tooltip"
          />
          <TreePage
            :usedInForm="true"
            :showAlertNotice="false"
            :showRoleSelected="true"
            limitSelected="1"
            :tags="role_selected"
            :generateRoleSelected="generateRoleSelectedOfTreePage"
            @updateRoleSelected="updatePreRoleSelected"
          />
          <b-form-invalid-feedback
            :state="$v.role_selected.$dirty ? !$v.role_selected.$error : null"
          >
            <div v-if="!$v.role_selected.required">
              {{
                $lang.error_required | replace($lang.profileLang.select_role)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_danger border-bottom pt-3">
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.start_at}: `"
            :rules="$v.start_at.$params"
          />
          <date-picker
            v-model="$v.start_at.$model"
            type="datetime"
            :state="$v.start_at.$dirty ? !$v.start_at.$error : null"
            inputReq="true"
            clearable
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            :class="
              $v.start_at.$dirty
                ? $v.start_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :state="$v.start_at.$dirty ? !$v.start_at.$error : null"
          >
            <div v-if="!$v.start_at.required">
              {{ $lang.error_required | replace($lang.profileLang.start_at) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.end_at}: `"
            :rules="$v.end_at.$params"
            :showInfo="true"
            :titleText="$lang.profileLang.select_term_state_end_at_tooltip"
          />
          <date-picker
            v-model="$v.end_at.$model"
            type="datetime"
            :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
            inputReq="true"
            clearable
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            :min="$v.start_at.$model | moment('YYYY-MM-DD HH:mm')"
            :class="
              $v.end_at.$dirty
                ? $v.end_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
          >
            <div v-if="!$v.end_at.required">
              {{ $lang.error_required | replace($lang.profileLang.end_at) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group label-cols="auto">
          <requiredComponent
            slot="label"
            :label="`${$lang.status}:`"
            :rules="$v.status_selected.$params"
          />
          <b-form-radio-group
            class="mt-2"
            v-model="$v.status_selected.$model"
            :options="status_options"
            name="status"
          >
            <b-form-invalid-feedback
              :state="
                $v.status_selected.$dirty ? !$v.status_selected.$error : null
              "
            >
              {{ $lang.error_required | replace($lang.status) }}
            </b-form-invalid-feedback>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right pt-3">
        <b-button
          variant="success"
          @click="submit"
          v-if="isAdmin(parentPermissions)"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pathOr, includes, startsWith } from "ramda";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import { isAdmin, renderEumOptions, priceFormat } from "@/shared/utils";
import TreePage from "@/components/tree/treePage";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  validations: {
    term_state_selected: {
      required: requiredIf((vm) => vm.mode === "add"),
    },
    state_prerequisite_name_selected: {},
    max_day_status_completed: { numeric },
    cost: { required: requiredIf((vm) => vm.hasPayment) },
    gate_selected: { required: requiredIf((vm) => vm.hasPayment) },
    role_selected: {},
    status_selected: { required },
    start_at: { required },
    end_at: { required },
  },
  components: { TreePage, datePicker: VuePersianDatetimePicker },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
    termCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      term_state_selected: null,
      term_state_options: [],
      term_state_loading: false,
      state_prerequisite_name_selected: null,
      state_prerequisite_name_disabled: false,
      max_day_status_completed: null,
      cost: null,
      gate_options: [],
      gate_selected: null,
      gate_loading: false,
      role_selected: [],
      generateRoleSelectedOfTreePage: false,
      status_selected: 1,
      start_at: null,
      end_at: null,
    };
  },
  computed: {
    hasPayment() {
      const termName = pathOr("", ["state_name"], this.term_state_selected);
      return startsWith("payment_", termName);
    },
    status_options() {
      return renderEumOptions("enable_disable");
    },
  },
  watch: {
    term_state_selected(termState) {
      const termName = pathOr(null, ["state_name"], termState);
      const prerequisiteName = pathOr(
        null,
        ["state_name"],
        this.state_prerequisite_name_selected
      );
      const condition =
        termName === "pre_register" &&
        (prerequisiteName !== "pre_register" || this.mode === "edit");
      if (condition) {
        this.state_prerequisite_name_selected = { ...termState };
      }
      this.state_prerequisite_name_disabled = condition;
    },
    item(value) {
      value && this.fetchData();
    },
  },
  created() {
    this.getTermStateCombo();
    this.getGateCombo();
  },
  methods: {
    pathOr,
    includes,
    startsWith,
    priceFormat,
    isAdmin,
    close() {
      this.$emit("close");
    },
    updatePreRoleSelected(data) {
      this.role_selected = data;
    },
    async getTermStateCombo() {
      try {
        this.term_state_loading = true;
        const url =
          this.$config.api_url + this.$config.profile.term_state_define_combo;
        const response = await this.$httpService.get(url);
        this.term_state_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_state_loading = false;
      }
    },
    async getGateCombo() {
      try {
        this.gate_loading = true;
        const url = this.$config.api_url + this.$config.profile.gate_combo;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.gate_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.gate_loading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      let payload = {
        state_name: pathOr(null, ["state_name"], this.term_state_selected),
        state_prerequisite_name: pathOr(
          null,
          ["state_name"],
          this.state_prerequisite_name_selected
        ),
        max_day_status_completed: this.max_day_status_completed,
        cost: this.cost,
        gate_code: pathOr(null, ["code"], this.gate_selected),
        role_code: pathOr(null, ["0", "code"], this.role_selected),
        is_enable: this.status_selected,
        start_date: this.start_at,
        end_date: this.end_at,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.term_state_selected = pathOr(null, ["state_name"], this.item);
        this.state_prerequisite_name_selected = pathOr(
          null,
          ["state_prerequisite_name"],
          this.item
        );
        this.max_day_status_completed = pathOr(
          null,
          ["max_day_status_completed"],
          this.item
        );
        this.gate_selected = pathOr(null, ["gate"], this.item);
        this.cost = pathOr(null, ["cost"], this.item);
        this.role_selected = this.item.role ? [this.item.role] : [];
        this.status_selected = this.item.is_enable;
        this.start_at = pathOr(null, ["start_date", "gregorian"], this.item);
        this.end_at = pathOr(null, ["end_date", "gregorian"], this.item);
        this.generateRoleSelectedOfTreePage = true;
      }
    },
  },
};
</script>